import React from "react"
import { cn } from "utils";

// size = "small" | "medium" | "large"
const Checkbox = React.forwardRef(({
    label,
    className,
    size = "medium",
    ...rest
}, ref) => {
    const randomId = cn("flexCheckDefault", String(Math.random() * 10000));
    return (
        <div className={cn("checkbox-input-container")}>
            <input
                ref={ref}
                className={cn("form-check-input", "checkbox-input", size, className)}
                type="checkbox"
                id={randomId}
                {...rest}
            />
            {label && (
                <label className="" for={randomId}>
                    {label}
                </label>
            )}
        </div>
    )
});

Checkbox.displayName = "Checkbox"

export default Checkbox;